import { render, staticRenderFns } from "./ChallengeDetailIdeaCard.vue?vue&type=template&id=2a862bad&scoped=true&"
import script from "./ChallengeDetailIdeaCard.vue?vue&type=script&lang=js&"
export * from "./ChallengeDetailIdeaCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a862bad",
  null
  
)

export default component.exports